import * as ActionTypes from './ItemCategory.actions';
import { StoreModel } from "../../shared/interfaces";
import { CriteriaModel, EmptyCriteria } from "../../shared/interfaces/CriteriaModel";
import { EmptyPaginator, PaginatorModel } from "../../shared/interfaces/PaginatorModel";

/*Defining the state shape*/
export interface State {
    requestProcessing: boolean;
    GetAllItemCategory: {
        requestProcessing: boolean;
        criteria: CriteriaModel;
        response: PaginatorModel;
    },
    GetAllCollectionType: {
        requestProcessing: boolean;
        criteria: CriteriaModel;
        response: PaginatorModel;
    },
    GetAllProductType: {
        requestProcessing: boolean;
        criteria: CriteriaModel;
        response: PaginatorModel;
    },
    GetAllOccasionType: {
        requestProcessing: boolean;
        criteria: CriteriaModel;
        response: PaginatorModel;
    },
    GetFestiveOccasionName: {
        response: any
    };
    GetAllFestiveOccasionItems: {
        requestProcessing: boolean;
        criteria: CriteriaModel;
        response: PaginatorModel;
    },
}

/*Setting the initial state*/
export const initialState: State = {
    requestProcessing: false,
    GetAllItemCategory: {
        requestProcessing: false,
        criteria: EmptyCriteria,
        response: EmptyPaginator,
    },
    GetAllCollectionType: {
        requestProcessing: false,
        criteria: EmptyCriteria,
        response: EmptyPaginator,
    },
    GetAllProductType: {
        requestProcessing: false,
        criteria: EmptyCriteria,
        response: EmptyPaginator,
    },
    GetAllOccasionType: {
        requestProcessing: false,
        criteria: EmptyCriteria,
        response: EmptyPaginator,
    },
    GetFestiveOccasionName: {
        response: null
    },
    GetAllFestiveOccasionItems: {
        requestProcessing: false,
        criteria: EmptyCriteria,
        response: EmptyPaginator,
    }
};

/*Creating the reducer function*/
export function ItemCategoryReducer(
    state = initialState,
    action: ActionTypes.Actions
): State {
    switch (action.type) {
        case ActionTypes.ActionTypes.GetAllItemCategory: {
            return {
                ...state,
                GetAllItemCategory: {
                    ...state.GetAllItemCategory,
                    requestProcessing: true,
                    criteria: action.payload,
                },
            };
        }
        case ActionTypes.ActionTypes.GetAllItemCategorySuccess: {
            return {
                ...state,
                GetAllItemCategory: {
                    ...state.GetAllItemCategory,
                    requestProcessing: false,
                    response: action.payload,
                },
            };
        }
        case ActionTypes.ActionTypes.GetAllItemCategoryError: {
            return {
                ...state,
                GetAllItemCategory: {
                    ...state.GetAllItemCategory,
                    requestProcessing: false,
                },
            };
        }

        case ActionTypes.ActionTypes.GetAllCollectionType: {
            return {
                ...state,
                GetAllCollectionType: {
                    ...state.GetAllCollectionType,
                    requestProcessing: true,
                    criteria: action.payload,
                },
            };
        }
        case ActionTypes.ActionTypes.GetAllCollectionTypeSuccess: {
            return {
                ...state,
                GetAllCollectionType: {
                    ...state.GetAllCollectionType,
                    requestProcessing: false,
                    response: action.payload,
                },
            };
        }
        case ActionTypes.ActionTypes.GetAllCollectionTypeError: {
            return {
                ...state,
                GetAllCollectionType: {
                    ...state.GetAllCollectionType,
                    requestProcessing: false,
                },
            };
        }

        case ActionTypes.ActionTypes.GetAllProductType: {
            return {
                ...state,
                GetAllProductType: {
                    ...state.GetAllProductType,
                    requestProcessing: true,
                    criteria: action.payload,
                },
            };
        }
        case ActionTypes.ActionTypes.GetAllProductTypeSuccess: {
            return {
                ...state,
                GetAllProductType: {
                    ...state.GetAllProductType,
                    requestProcessing: false,
                    response: action.payload,
                },
            };
        }
        case ActionTypes.ActionTypes.GetAllProductTypeError: {
            return {
                ...state,
                GetAllProductType: {
                    ...state.GetAllProductType,
                    requestProcessing: false,
                },
            };
        }

        case ActionTypes.ActionTypes.GetAllOccasionType: {
            return {
                ...state,
                GetAllOccasionType: {
                    ...state.GetAllOccasionType,
                    requestProcessing: true,
                    criteria: action.payload,
                },
            };
        }
        case ActionTypes.ActionTypes.GetAllOccasionTypeSuccess: {
            return {
                ...state,
                GetAllOccasionType: {
                    ...state.GetAllOccasionType,
                    requestProcessing: false,
                    response: action.payload,
                },
            };
        }
        case ActionTypes.ActionTypes.GetAllOccasionTypeError: {
            return {
                ...state,
                GetAllOccasionType: {
                    ...state.GetAllOccasionType,
                    requestProcessing: false,
                },
            };
        }

        case ActionTypes.ActionTypes.GetFestiveOccasionName: {
            return {
                ...state,
                requestProcessing: true,
                GetFestiveOccasionName: {
                    response: null
                }
            };
        }
        case ActionTypes.ActionTypes.GetFestiveOccasionNameSuccess: {
            return {
                ...state,
                requestProcessing: false,
                GetFestiveOccasionName: {
                    response: action.payload
                }
            };
        }
        case ActionTypes.ActionTypes.GetFestiveOccasionNameError: {
            return {
                ...state,
                requestProcessing: false,
            }
        }

        case ActionTypes.ActionTypes.GetAllFestiveOccasionItems: {
            return {
                ...state,
                GetAllFestiveOccasionItems: {
                    ...state.GetAllFestiveOccasionItems,
                    requestProcessing: true,
                    criteria: action.payload,
                },
            };
        }
        case ActionTypes.ActionTypes.GetAllFestiveOccasionItemsSuccess: {
            return {
                ...state,
                GetAllFestiveOccasionItems: {
                    ...state.GetAllFestiveOccasionItems,
                    requestProcessing: false,
                    response: action.payload,
                },
            };
        }
        case ActionTypes.ActionTypes.GetAllFestiveOccasionItemsError: {
            return {
                ...state,
                GetAllFestiveOccasionItems: {
                    ...state.GetAllFestiveOccasionItems,
                    requestProcessing: false,
                },
            };
        }

        default:
            return state;
    }
}
